import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect } from 'react'
import { BallTriangle } from 'react-loader-spinner';
import { Link, useParams } from 'react-router-dom';
import { isEmpty } from 'underscore';
import AlumniService from '../../services/AlumniService';


export const AlumniVideoPage: FC = () => {
    const { videoId } = useParams();
    const [data, setData] = useState<any>({});
    const [loader, setLoader] = useState<boolean>(false);

    const date = isEmpty(data) ? '' : data['create_date'].split('T');
    const formattedDate = date === '' ? '' : date[0].split('-');

    const getVideo = async () => {
        try {
            const res = await AlumniService.getVideo(Number(videoId));
            setData(res.data);
            setLoader(false);
        } catch (e) {
            setData({ id: videoId, header: '', create_date: '', author: '', text: 'Страница не найдена' });
            setLoader(false);
        }
    }
    // var htmlObject = document.createElement('div');
    // htmlObject.innerHTML = data['text'];
    useEffect(() => {
        setLoader(true);
        getVideo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoId]);

    const [images, setImages] = useState<any[]>([]);

    const getImages = () => {
        let imgMass = []
        if (!isEmpty(data)) {
            for (let i = 2; i < 10; i++) {
                if (data[`image${i}`]) {
                    imgMass.push(data[`image${i}`]);
                }
            };
        }
        setImages(imgMass);
    };

    useEffect(() => {
        getImages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div className="row m-3">
            <div className="mb-2">
                <Link to={`/alumni_videos`}><button className="btn btn-light" ><i className="icon arrow-left"></i><Trans>Back</Trans></button></Link>
            </div>
            <div className="form-group mb-5">
                <iframe className='w-100' src={data['video_link']} height="600" title={`video_${data['id']}`}></iframe>
                <div className="row justify-content-beetwen">
                    <h3 className="col-9 event-header">{data['header']}</h3>
                    <div className="col-3 text-end mt-2"><Trans>Viewed</Trans>: {data['viewed']}</div>
                </div>

                <hr />
                <div className="row">
                    <div className="col-9">
                        <div className="h5 event-header"><Trans>Graduate</Trans>: {data['alumni_fio']}</div>
                        <div className='mb-2'><Trans>Graduation year</Trans>: {data['issue_year']}</div>
                        <div className='mb-2'><Trans>School</Trans>: {data['school']}</div>
                        <div><Trans>Municipality</Trans>: {data['municipality']}</div>
                    </div>
                    <div className="col-3">
                        <div className="mb-2 text-end"><Trans>Author</Trans>: {data['author']}</div>
                        <div className="text-end"><Trans>Publication date</Trans>: {formattedDate[2]}.{formattedDate[1]}.{formattedDate[0]}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};